import { render, staticRenderFns } from "./FollowerGoal.vue?vue&type=template&id=1ad03330"
import script from "./FollowerGoal.vue?vue&type=script&lang=js"
export * from "./FollowerGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports